import React, { Component } from 'react';

let keyWasPressed = false;
let me;

class Filtro extends Component {
    constructor(props) {
        super(props);
        me = this;

        this.limpiarFiltro = this.limpiarFiltro.bind(this);
    }

    findEntidades(event) {
        const { entidades } = me.props.data;

        let filtro = event.target.value.toString().toLowerCase();

        me.props.findEntidades(filtro);

        keyWasPressed = false;
    }

    limpiarFiltro() {
        this.props.findEntidades("");
    }

    keyDown (event) {
        //backspace = 8, tab = 9, enter = 13, ctrol = 17, shift = 16, alt = 18, [left = 37, up = 38, rigth = 39, down = 40] (flechas)
        //=> no se deben considerar como tecla presionada

        let keyNotAllowed = [9, 13, 16, 17, 18, 37, 38, 39, 40];

        if (keyNotAllowed.indexOf(event.keyCode) < 0) {
            keyWasPressed = true;
        }
    }

    onFocus (event) {
        keyWasPressed = false;
    }

    onKeyPress (event) {
        let regExp = /[a-z0-9ñÑáéíóúÁÉÍÓÚ\s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        let messageError = <label className="error zmdi-alert-circle">No se encontro la entidad.</label>;
        return (
            <div className="row">
                <div className="col-md-12">
                    <input id="buscarentidad"
                        name="buscarentidad"
                        value={me.props.data.filtro}
                        className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs"
                        onChange={me.findEntidades}
                        onKeyDown={me.keyDown}
                        onFocus={me.onFocus}
                        onKeyPress={me.onKeyPress}
                        placeholder="Buscar por nombre." />
                    <span>{me.props.data.showErrorMessage && messageError}</span>
                </div>
                {me.props?.data?.filtro?.length > 0 ? 
                <div className="btn-group-Borrar-Filtro">
                    <button id={"botonBorrarFiltroBuscarEntidad"} type="button" className="btn-tag VistaInstanciaParametro-Filtros-Limpiar-Filtro"
                        onClick={this.limpiarFiltro}>
                        <span id={"botonBorrarXFiltroBuscarEntidad"} className="ti-close span-closable" />
                    </button>
                </div>
                :
                null
                }
            </div>
        );
    }
};

export default Filtro